const Note = ({ note }) => {
  return (
    note && (
      <div className='space-y-2 text-sm'>
        <div className='text-white font-bold'>Note</div>
        <div className='text-white bg-tertiary rounded-xl px-3 py-2 whitespace-pre'>
          {note}
        </div>
      </div>
    )
  );
};

export default Note;
